import { Link, useLocation} from "react-router-dom";

import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import backgroundImg from "./../assets/nightsky/24.jpg";
import Typed from 'typed.js';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {recognitions, getOfficeInfo} from './updatables';

import { MotionIcon } from 'motion-icons-react';
import { ItemWrapper } from "./Sidebar/SidebarStyles";
import { ThemeContext } from "./../ThemeContext";
import { supabase } from "./../supabaseClient";

const AboutMe = ({page}) => {

    const el = React.useRef(null);
    const el2 = React.useRef(null);

    const location = useLocation();

    const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    const [office, setOffice] = React.useState([]);

    React.useEffect(() => {
        async function loadOffice() {
            const data = await getOfficeInfo();
            console.log("office:", data);
            setOffice(data);
        }

        loadOffice();
    }, []);

    return <div class="body" style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, color: "black", display: "inline-block", justifyContent: "space-between", padding: "16px", margin: "0px"}}>
        <span class="body" style={{fontSize: "30px"}}>Hello, I'm Ori Friesen.</span>
        <br/>
        I'm a mathematician, cartographer, web developer, and night-sky photographer.
        <br/>
        <br/>
        <p class="body" style={{fontSize: "22px", color: "black"}}><img src={require("./../assets/ori_image.jpg")} alt="me!" style={{width: "250px", paddingLeft: "12px"}}></img>I am currently a second-year Theoretical Mathematics PhD student at <a href="https://math.osu.edu/" target="_blank" rel="noopener noreferrer" style={{fontFamily: "Garamond, serif", fontSize: "28px", textDecoration: "underline"}}>the Ohio State University</a>.</p>

        <a 
            onClick={() => {
                const { data } = supabase.storage
                    .from("pdfs")
                    .getPublicUrl("ori-friesen-cv.pdf");

                window.open(data.publicUrl, "_blank", "noopener,noreferrer");
            }}
            class="body" style={{padding: "2px", fontSize: "28px", cursor: "pointer", textDecoration: "underline"}}
        >
            Open CV
        </a>
        <br/>
        <p class="body" style={{fontSize: "22px", color: "black"}}>Office Location: <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{office[0]?.room}</span></p>

        <p class="body" style={{fontSize: "22px", color: "black"}}>Office Hours: <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{office[0]?.hours}</span></p>

    </div>};

export default AboutMe;